<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group
          :label="hideTitle ? '' : 'Add Ons'"
          :label-cols="hideTitle ? 0 : 3"
          :horizontal="true"
        >
          <multiselect
            :multiple="isMultiple"
            v-model="selected"
            :placeholder="customPlaceholder"
            :options="options || []"
            label="name"
            trackBy="id"
          >
          </multiselect>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "AddOnSelect",
  components: { Multiselect },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    selectedOption: {
      type: String,
      default: () => null
    },
    hideTitle: {
      type: Boolean,
      default: () => false
    },
    customPlaceholder: {
      type: String,
      default: () => "Select an option"
    },
    isMultiple: {
      type: Boolean,
      default: () => true
    }
  },
  computed: {
    selected: {
      get() {

        if (this.isMultiple)
          return (
            (this.options &&
              this.selectedOption &&
              this.selectedOption.length &&
              this.selectedOption.map(item => {
                return this.options.find(option => option.id === item.id);
              })) ||
            null
          );
        return (
          (this.options &&
            this.options.find(option => option.id === this.selectedOption)) ||
          null
        );
      },
      set(value) {
        if (this.isMultiple) {
          this.$emit("onAddOnSelect", (value && value.length && value) || null);
        } else {
          this.$emit("onAddOnSelect", value || null);
        }
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
